import NakedButton from '@Components/Buttons/NakedButton'
import Button from '@Components/Buttons/Button'
import CheckBox from '@Components/Selectors/Checkbox'
import React from 'react'
import './index.scss'
import { observer } from 'mobx-react'
import ModalPortal from '@Components/Popups/ModalPortal'
import { BulkActionStore, LeavePageSource } from '@App/stores/search/bulk-action-store'
import { PaginationBody } from '@Entities/pagination'

interface BulkActionControlProps<T, TAction extends string, Tsteps extends string> {
    enabledWorks: T[]
    idList: number[]
    bulkSelectionCountText: string
    totalSelectionCount: number
    bulkActionStore: BulkActionStore<TAction, Tsteps>
    pagination: PaginationBody
    isSubmitDisabled?: boolean
    submitButtonText?: string
    submitButtonOnClick?: () => void
    instructions?: string
    displayConfirmationPopup?: boolean
    confirmationPopup?: React.JSX.Element
}
const BulkActionControl = <T extends object, TAction extends string, Tsteps extends string>(
    props: BulkActionControlProps<T, TAction, Tsteps>
) => {
    const {
        enabledWorks,
        idList,
        bulkSelectionCountText,
        totalSelectionCount,
        bulkActionStore,
        pagination,
        isSubmitDisabled,
        submitButtonText,
        submitButtonOnClick,
        instructions,
        displayConfirmationPopup,
        confirmationPopup,
    } = props

    const selectedOnPage = idList.filter((id) => bulkActionStore.idsSelectedForBulkAction.has(id))
    const isPageSelected = enabledWorks.length > 0 && selectedOnPage.length === enabledWorks.length

    const handleSelectPage = () => {
        if (isPageSelected) {
            bulkActionStore.removeMultipleFromSelection(selectedOnPage)
        } else {
            bulkActionStore.addMultipleToSelection(idList)
        }
    }

    const handleCancelBulkAction = () => {
        if (bulkActionStore.idsSelectedForBulkAction.size > 0 || bulkActionStore.areFilesStaged) {
            bulkActionStore.setLeavePageModalOpen(pagination, LeavePageSource.BackButton)
        } else {
            bulkActionStore.setActiveBulkAction(null)
        }
    }

    return (
        <div className="bulk-action-control-wrapper">
            {confirmationPopup && <ModalPortal isOpen={!!displayConfirmationPopup}>{confirmationPopup}</ModalPortal>}
            {instructions && <div className="bulk-action-instructions">{instructions}</div>}
            <div className="bulk-action-control">
                <NakedButton aria-label="Cancel bulk action" onClick={handleCancelBulkAction}>
                    {'< Back'}
                </NakedButton>
                <Button
                    className="select-all"
                    mainColor={false}
                    type="primary"
                    disabled={enabledWorks.length === 0}
                    onClick={handleSelectPage}
                >
                    <CheckBox
                        id="select-all"
                        checked={isPageSelected && enabledWorks.length > 0}
                        onClick={handleSelectPage}
                        mainColor={false}
                        disabled={enabledWorks.length === 0}
                    />
                    Select Page (up to 100)
                </Button>
                <Button mainColor={false} type="primary" onClick={() => bulkActionStore.resetSelection()}>
                    Clear all selections
                </Button>
                <Button mainColor disabled={isSubmitDisabled} onClick={submitButtonOnClick} type="primary">
                    {submitButtonText}
                </Button>
            </div>
            <div className="bulk-selection-count">
                {bulkActionStore.idsSelectedForBulkAction.size} of {totalSelectionCount} total songs selected for bulk{' '}
                {bulkSelectionCountText}
            </div>
        </div>
    )
}
export default observer(BulkActionControl)
